import React, { useState, forwardRef, useImperativeHandle } from 'react';

import '../../../styles/AsyncValidationEditor.css';
import { useSelector } from 'react-redux';

import RemoteAutocomplete from '../RemoteAutocomplete';
import { asyncSearchForProducts } from '../../../utils/controllers/ProductsSearchController';
import { getAuth0token } from '../../../redux/selectors/mainSelectors';

export default forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value);
    const token = useSelector(getAuth0token);

    const handleChange = product => {
        if (!value.originalValue) {
            setValue(product ? { displayValue: product.name, originalValue: value.displayValue, hasBeenEdited: true } : null);
        } else {
            setValue(product ? { displayValue: product.name, originalValue: value.originalValue, hasBeenEdited: true } : null);
        }
    };

    useImperativeHandle(ref, () => {
        return {
            getValue: () => {
                return value;
            },
            afterGuiAttached: () => {
                setValue(props.value);
            },
        };
    });

    return (
        <RemoteAutocomplete
            noWait
            onSelect={handleChange}
            asyncFetchFunction={value => asyncSearchForProducts(token, value)}
            placeholder={value ? (value.originalValue ? value.originalValue : value.displayValue) : null}
            defaultValue={value ? value.displayValue : null}
        />
    );
});
